import { getSingleSeries, getSingleSeriesInfo } from '../../../../api/series';
import Audio from '../components/Audio';
import Subtitles from '../components/Subtitles';
export default function (page, { serieId }) {
  return getSingleSeriesInfo(serieId).then(({ data }) => {
    const series = data.movie;
    const lang = [
      'en-US',
      'english-scripture',
      'español-scripture',
      'portuguese-scripture',
      'es',
      'pt',
    ];
    const subtitlesLinks = [
      {
        id: 0,
        src: 'none',
        languageName: 'None',
        lng: 'none',
      },
    ];

    const audiosLinks = [];

    lang.forEach((el) => {
      const language = series.languages[el];
      language.subtitles_file &&
        subtitlesLinks.push({
          id: subtitlesLinks.length + 1,
          lng: el,
          languageName: language.language_name,
        });
      language.has_localized_movie_file &&
        audiosLinks.push({
          id: audiosLinks.length + 1,
          src: language.has_localized_movie_file,
          languageName: language.language_name,
          lng: el,
        });
    });

    const subtitles = subtitlesLinks.map((subtitle, index) => ({
      collision: true,
      index,
      type: Subtitles,
      subtitle,
      serieId,
    }));

    const audioLinks = audiosLinks.map((audio, index) => ({
      index,
      collision: true,
      type: Audio,
      audio,
      serieId,
    }));

    page.serieId = serieId;
    page._Subtitles.items = subtitles;
    page._Audio.items = audioLinks;
  });
}
